// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/trHarlequin.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/NPC10.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppLogo {
  margin: 0 10px 0 0;
  width: 40px;
}
.mainContainer {
  margin-top: 80px;
}
a.headerMenu {
  color: #fff;
  margin-left: 0.5em;
  text-decoration: none;
}
.drawerListMenu a {
  color: #6b7a8f;
  display: block;
}
.AppLogoHome {
  width: 50%;
}
.sfButtonCont > * {
  margin-left: 10px !important;
  margin-top: 10px !important;
}
.SandBoxContainer {
  background-color: black;
  width: 800px;
  height: 600px;
}

.mapa{
    position: relative;
    border: 1px solid black;
    width: fit-content;
}

.Character {
  width: 64px;
  height: 64px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
}

.autoCharacter {
    width: 64px;
    height: 64px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat; 
}
.down,
.up,
.left,
.right {
  animation: walk-cycle 0.5s steps(4) infinite;
}

.down {
  background-position-y: 0;
}
.up {
  background-position-y: -192px;
}
.left {
  background-position-y: -64px;
}
.right {
  background-position-y: -128px;
}

.SandBoxBeeContainer {
  background-color: black;
  width: 800px;
  height: 600px;
  position: relative;
}

.Bee {
  width: 4px;
  height: 4px;
  background-color: beige;
  position: absolute;
}

.Bee1 {
  width: 4px;
  height: 4px;
  background-color:coral;
  position: absolute;
}
.Bee2 {
  width: 4px;
  height: 4px;
  background-color: beige;
  position: absolute;
}
.Bee3 {
  width: 4px;
  height: 4px;
  background-color:chartreuse;
  position: absolute;
}
.Bee4 {
  width: 4px;
  height: 4px;
  background-color:blueviolet;
  position: absolute;
}
.Bee5 {
  width: 4px;
  height: 4px;
  background-color:rgb(202, 0, 10);
  position: absolute;
}

.breadcrumbs {
  margin: 0 0 1em 0 !important;
}

.breadcrumbs a {
  text-decoration: none;
  color: #c1c1c1;
}

.breadcrumbs a:not(:first-child):before,
.breadcrumbs span:not(:first-child):before {
  content: ">";
  color: #c1c1c1;
  padding-right: 0.5em;
  margin-left: 0.5em;
}

/* INI GOOGLE SIGN IN */
.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  max-width: 400px;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  -webkit-flex-grow: 1;
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity .218s;
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state, 
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}
/* FIN GOOGLE SIGN IN */

.instrucciones-widget {
  font-family: 'Roboto', 'Segoe UI', sans-serif;
  max-width: 800px;
  margin: 0 auto;
}

.codigo-instalacion {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 16px;
  margin: 16px 0;
  overflow-x: auto;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.5;
}

.codigo-instalacion code {
  color: #333;
  display: block;
  text-align: left;
}

/* Resaltar partes importantes */
.codigo-instalacion .highlight {
  color: #0066cc;
  font-weight: bold;
}

/* Opcionalmente: Dar estilo a los elementos específicos */
.codigo-instalacion .tag {
  color: #881280;
}

.codigo-instalacion .attribute {
  color: #994500;
}

.codigo-instalacion .string {
  color: #008000;
}

a.product-url {
  word-break: break-all;
  overflow-wrap: break-word;
  display: inline-block;
  max-width: 100%;
}

@keyframes walk-cycle {
  100% {
    background-position-x: -256px;
  }
}
`, "",{"version":3,"sources":["webpack://./public/assets/css/main.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yDAA8D;EAC9D,4BAA4B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAwD;IACxD,4BAA4B;AAChC;AACA;;;;EAIE,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gFAAgF;EAChF,wEAAwE;EACxE,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0FAA0F;EAC1F,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA,uBAAuB;;AAEvB;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,2DAA2D;EAC3D,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF","sourcesContent":[".AppLogo {\r\n  margin: 0 10px 0 0;\r\n  width: 40px;\r\n}\r\n.mainContainer {\r\n  margin-top: 80px;\r\n}\r\na.headerMenu {\r\n  color: #fff;\r\n  margin-left: 0.5em;\r\n  text-decoration: none;\r\n}\r\n.drawerListMenu a {\r\n  color: #6b7a8f;\r\n  display: block;\r\n}\r\n.AppLogoHome {\r\n  width: 50%;\r\n}\r\n.sfButtonCont > * {\r\n  margin-left: 10px !important;\r\n  margin-top: 10px !important;\r\n}\r\n.SandBoxContainer {\r\n  background-color: black;\r\n  width: 800px;\r\n  height: 600px;\r\n}\r\n\r\n.mapa{\r\n    position: relative;\r\n    border: 1px solid black;\r\n    width: fit-content;\r\n}\r\n\r\n.Character {\r\n  width: 64px;\r\n  height: 64px;\r\n  background-image: url(\"/public/assets/images/trHarlequin.png\");\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.autoCharacter {\r\n    width: 64px;\r\n    height: 64px;\r\n    background-image: url(\"/public/assets/images/NPC10.png\");\r\n    background-repeat: no-repeat; \r\n}\r\n.down,\r\n.up,\r\n.left,\r\n.right {\r\n  animation: walk-cycle 0.5s steps(4) infinite;\r\n}\r\n\r\n.down {\r\n  background-position-y: 0;\r\n}\r\n.up {\r\n  background-position-y: -192px;\r\n}\r\n.left {\r\n  background-position-y: -64px;\r\n}\r\n.right {\r\n  background-position-y: -128px;\r\n}\r\n\r\n.SandBoxBeeContainer {\r\n  background-color: black;\r\n  width: 800px;\r\n  height: 600px;\r\n  position: relative;\r\n}\r\n\r\n.Bee {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color: beige;\r\n  position: absolute;\r\n}\r\n\r\n.Bee1 {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color:coral;\r\n  position: absolute;\r\n}\r\n.Bee2 {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color: beige;\r\n  position: absolute;\r\n}\r\n.Bee3 {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color:chartreuse;\r\n  position: absolute;\r\n}\r\n.Bee4 {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color:blueviolet;\r\n  position: absolute;\r\n}\r\n.Bee5 {\r\n  width: 4px;\r\n  height: 4px;\r\n  background-color:rgb(202, 0, 10);\r\n  position: absolute;\r\n}\r\n\r\n.breadcrumbs {\r\n  margin: 0 0 1em 0 !important;\r\n}\r\n\r\n.breadcrumbs a {\r\n  text-decoration: none;\r\n  color: #c1c1c1;\r\n}\r\n\r\n.breadcrumbs a:not(:first-child):before,\r\n.breadcrumbs span:not(:first-child):before {\r\n  content: \">\";\r\n  color: #c1c1c1;\r\n  padding-right: 0.5em;\r\n  margin-left: 0.5em;\r\n}\r\n\r\n/* INI GOOGLE SIGN IN */\r\n.gsi-material-button {\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  -webkit-appearance: none;\r\n  background-color: WHITE;\r\n  background-image: none;\r\n  border: 1px solid #747775;\r\n  -webkit-border-radius: 4px;\r\n  border-radius: 4px;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  color: #1f1f1f;\r\n  cursor: pointer;\r\n  font-family: 'Roboto', arial, sans-serif;\r\n  font-size: 14px;\r\n  height: 40px;\r\n  letter-spacing: 0.25px;\r\n  outline: none;\r\n  overflow: hidden;\r\n  padding: 0 12px;\r\n  position: relative;\r\n  text-align: center;\r\n  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;\r\n  transition: background-color .218s, border-color .218s, box-shadow .218s;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n  width: auto;\r\n  max-width: 400px;\r\n  min-width: min-content;\r\n}\r\n\r\n.gsi-material-button .gsi-material-button-icon {\r\n  height: 20px;\r\n  margin-right: 12px;\r\n  min-width: 20px;\r\n  width: 20px;\r\n}\r\n\r\n.gsi-material-button .gsi-material-button-content-wrapper {\r\n  -webkit-align-items: center;\r\n  align-items: center;\r\n  display: flex;\r\n  -webkit-flex-direction: row;\r\n  flex-direction: row;\r\n  -webkit-flex-wrap: nowrap;\r\n  flex-wrap: nowrap;\r\n  height: 100%;\r\n  justify-content: space-between;\r\n  position: relative;\r\n  width: 100%;\r\n}\r\n\r\n.gsi-material-button .gsi-material-button-contents {\r\n  -webkit-flex-grow: 1;\r\n  flex-grow: 1;\r\n  font-family: 'Roboto', arial, sans-serif;\r\n  font-weight: 500;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: top;\r\n}\r\n\r\n.gsi-material-button .gsi-material-button-state {\r\n  -webkit-transition: opacity .218s;\r\n  transition: opacity .218s;\r\n  bottom: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.gsi-material-button:disabled {\r\n  cursor: default;\r\n  background-color: #ffffff61;\r\n  border-color: #1f1f1f1f;\r\n}\r\n\r\n.gsi-material-button:disabled .gsi-material-button-contents {\r\n  opacity: 38%;\r\n}\r\n\r\n.gsi-material-button:disabled .gsi-material-button-icon {\r\n  opacity: 38%;\r\n}\r\n\r\n.gsi-material-button:not(:disabled):active .gsi-material-button-state, \r\n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\r\n  background-color: #303030;\r\n  opacity: 12%;\r\n}\r\n\r\n.gsi-material-button:not(:disabled):hover {\r\n  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\r\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);\r\n}\r\n\r\n.gsi-material-button:not(:disabled):hover .gsi-material-button-state {\r\n  background-color: #303030;\r\n  opacity: 8%;\r\n}\r\n/* FIN GOOGLE SIGN IN */\r\n\r\n.instrucciones-widget {\r\n  font-family: 'Roboto', 'Segoe UI', sans-serif;\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.codigo-instalacion {\r\n  background-color: #f5f5f5;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 16px;\r\n  margin: 16px 0;\r\n  overflow-x: auto;\r\n  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.codigo-instalacion code {\r\n  color: #333;\r\n  display: block;\r\n  text-align: left;\r\n}\r\n\r\n/* Resaltar partes importantes */\r\n.codigo-instalacion .highlight {\r\n  color: #0066cc;\r\n  font-weight: bold;\r\n}\r\n\r\n/* Opcionalmente: Dar estilo a los elementos específicos */\r\n.codigo-instalacion .tag {\r\n  color: #881280;\r\n}\r\n\r\n.codigo-instalacion .attribute {\r\n  color: #994500;\r\n}\r\n\r\n.codigo-instalacion .string {\r\n  color: #008000;\r\n}\r\n\r\na.product-url {\r\n  word-break: break-all;\r\n  overflow-wrap: break-word;\r\n  display: inline-block;\r\n  max-width: 100%;\r\n}\r\n\r\n@keyframes walk-cycle {\r\n  100% {\r\n    background-position-x: -256px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
